/**
 * Section name constants (code-friendly names)
 * These are used in the database and should not change even if UI labels change
 */
export const SECTION_NAMES = {
  PROJECT_INFORMATION: 'project-information',
  PRODUCT_DETAILS: 'product-details',
  MARKET_LANDSCAPE: 'market-landscape',
  CURRENT_MARKET_STATE: 'current-market-state',
  COGS_BUILDUP: 'cogs-buildup',
  PRICING_CALCULATOR: 'pricing-calculator',
  FSS_TRACKING: 'fss-tracking',
  PACK_SIZE_OUTPUT: 'pack-size-output',
  COMPETITIVE_ANALYSIS: 'competitive-analysis',
  CONTRACT_PRICE_RANKING: 'contract-price-ranking',
  COMMERCIAL_PRICE_RANKING: 'commercial-price-ranking',
  TMOP_CALCULATOR: 'tmop-calculator',
  GLOBAL_OUTPUT: 'global-output',
} as const;

/**
 * Section name to display name mapping
 */
export const SECTION_DISPLAY_NAMES: Record<string, string> = {
  [SECTION_NAMES.PROJECT_INFORMATION]: 'Project Information',
  [SECTION_NAMES.PRODUCT_DETAILS]: 'Product Details',
  [SECTION_NAMES.MARKET_LANDSCAPE]: 'Market Landscape',
  [SECTION_NAMES.CURRENT_MARKET_STATE]: 'Current Market State',
  [SECTION_NAMES.COGS_BUILDUP]: 'COGS Buildup',
  [SECTION_NAMES.PRICING_CALCULATOR]: 'Pricing Calculator',
  [SECTION_NAMES.FSS_TRACKING]: 'FSS Tracking',
  [SECTION_NAMES.PACK_SIZE_OUTPUT]: 'Pack Size Output',
  [SECTION_NAMES.COMPETITIVE_ANALYSIS]: 'Competitive Analysis',
  [SECTION_NAMES.CONTRACT_PRICE_RANKING]: 'Contract Price Ranking',
  [SECTION_NAMES.COMMERCIAL_PRICE_RANKING]: 'Commercial Price Ranking',
  [SECTION_NAMES.TMOP_CALCULATOR]: 'TMOP Calculator',
  [SECTION_NAMES.GLOBAL_OUTPUT]: 'Global Output',
  'manager_modification': 'Manager Notes', // Backend section for manager modification notes
};

/**
 * Get display name for a section code
 */
export const getSectionDisplayName = (sectionCode: string): string => {
  return SECTION_DISPLAY_NAMES[sectionCode] || sectionCode;
};

